export class AssetLinkDTO {
  linkId: number;

  assetId: number;

  pinned: boolean;

  linkURLFragment?: string;

  constructor() {
    this.linkId = -1;
    this.assetId = -1;
    this.pinned = false;
  }
}
